import React from 'react'

import screenShot from './graphics/me.m01.d06.meVE.Apolytikion1.text.png'

export default React.createClass({
  render() {
    return <img role="presentation" src={screenShot} height="100%" width="100%"/>
  }
})



// WEBPACK FOOTER //
// ./src/images/MeM1D1A1.js